import React from 'react';
import './skills.scss';

const SKILLS = [{ type: 'HTML', level: 99 }, { type: 'CSS', level: 98 }];

class SkillBars extends React.Component {
  constructor(props) {
    super(props);
    this.state = { collapsed: true };
  }

  setColor = level => {
    switch (true) {
      case level >= 0 && level <= 20:
        return 'rgb(224, 216, 216)';
      case level > 20 && level <= 35:
        return 'rgb(240, 222, 61)';
      case level > 35 && level <= 50:
        return 'rgb(255, 145, 42)';
      case level > 50 && level <= 70:
        return 'rgb(134, 255, 97)';
      case level > 70 && level <= 80:
        return 'rgb(97, 205, 255)';
      case level > 80 && level <= 90:
        return 'rgb(115, 242, 247)';
      case level > 90 && level <= 100:
        return 'rgb(139, 137, 240)';
      default:
        return 'rgb(224, 216, 216)';
    }
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ collapsed: false });
    }, 500);
  }

  render() {
    const { collapsed } = this.state;
    const { skills } = this.props;
    const newSkills = skills.map(skill => {
      skill.color = this.setColor(skill.level);
      return skill;
    });

    return (
      <div id='app' className={`container ${collapsed ? 'collapsed' : ''}`}>
        <ul className='skills'>
          {newSkills.map(skill => (
            <li
              key={skill.type}
              style={{
                width: `${skill.level}%`,
                backgroundColor: `${skill.color}`,
              }}
            >
              <p>
                {skill.type}
                <span style={{ opacity: 1 }}>{skill.level}%</span>
              </p>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

SkillBars.defaultProps = {
  skills: SKILLS,
};

export default SkillBars;
